export default __webpack_public_path__ + "static/media/keep-distance.2d7fb8d4.png";